module.exports = __webpack_public_path__ + "static/img/200262.7445cdb3.png";